import { render, staticRenderFns } from "./addSkin.vue?vue&type=template&id=9a84d712&scoped=true&"
import script from "./addSkin.vue?vue&type=script&lang=js&"
export * from "./addSkin.vue?vue&type=script&lang=js&"
import style0 from "./addSkin.vue?vue&type=style&index=0&id=9a84d712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a84d712",
  null
  
)

export default component.exports